import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getZoomPercentage } from '../../selectors/handoff';
import { incrementZoom, decrementZoom, fitZoom } from '../../actionCreators';
import Zoom from '../../components/handoff/Zoom';
function mapStateToProps(state) {
    return {
        zoom: getZoomPercentage(state),
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        incrementZoom: incrementZoom,
        decrementZoom: decrementZoom,
        fitZoom: fitZoom,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Zoom);
